import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideCalendarDays } from "lucide-react";
import HolidayCard from "./HolidayCard";
import SelectOption from "components/select/SelectOption";
import { 
  getCountryList
} from "../../../../redux/optionlist/optionlistState";
import {
	getHolidayList
} from "../../../../redux/overview/overviewState";
import { handleTableChange } from "utils";

const PublicHolidaysTable = ({
	countryList, 
	getCountry, 
	filters, 
	recordList,
	getList
}) => {

useEffect(() => {
	getCountry();
	getList();
}, [getCountry, getList]);

const onSelectFilter = (field, value) => {
    const data = {
      ...(filters || {}),
      [field]: value,
      page: 1,
      paginate: 10,
    };

	if (value && value !== "all") {
      data[field] = value;
    } else {
      delete data[field];
    }
    
    getList(data);
};


	
return (
	<HeaderComponent
		title="Public Holidays"
		description="Holidays by location"
		bgcolor="bg-emerald-50/30"
		icon={<LucideCalendarDays size={20}/>}
		colorTheme="flat-emerald"
		shadow="shadow-sm"
		border="border-b"
		rightNav={
			<SelectOption
				placeholder="All Locations"
				options={countryList}
				value={filters?.country_id}
				onChange={(value) => onSelectFilter("country_id", value)}
				showIcons={true}
				showLabel={true}
				showSelectedIconOnly={true}
			/>
		}
	>
		<div className="pt-10 flex-1">
			<div className= "relative pr-1 h-[500px] overflow-y-auto">
				<div className="space-y-3">
					{recordList?.data?.map((item) => (
						<HolidayCard 
							key={item?.hol_id}        
							{...item}
							onChange={handleTableChange(getList, filters)}
						/>
					))}
				</div>
			</div>
		</div>
		
	</HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
	countryList: state.optionlist.countryList?.items,
	recordList: state.overview.teamHolidayList?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getCountry: (data) => dispatch(getCountryList(data)),
	getList: (filters) => dispatch(getHolidayList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicHolidaysTable);
